<template>
  <div class="VChart">
    <div ref="EChart" class="EChartCom"></div>
    <div class="rate">
      <div class="title">{{ propValue.title }}</div>
      <div class="rateNum">{{ propValue.rateNum }}</div>
    </div>
  </div>
</template>

<script>
import OnEvent from '../common/OnEvent.vue'
import * as Echart from 'echarts'
export default {
  extends: OnEvent,
  props: {
    propValue: {
      type: Object,
      require: true,
      default: () => {}
    },
    element: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    curComponent() {
      return this.$store.state.compose.curComponent
    }
  },
  watch: {
    // 监听组件修改的内容，响应式修改数据
    element: {
      deep: true,
      handler(newval, val) {
        this.render()
      }
    }
  },
  mounted() {
    // 初始化echarts，渲染大小
    this.echart = Echart.init(this.$refs.EChart, null, {
      width: this.element.style.width,
      height: this.element.style.height
    })
    this.render()
  },
  methods: {
    render() {
      const EChart = this.echart
      const option = this.propValue.option
      // 设置参数
      const config = {
        ...option
      }
      // 更新大小
      this.echart.resize({
        width: this.element.style.width,
        height: this.element.style.height
      })
      // 配置参数
      EChart.setOption(config)
    }
  }
}
</script>

<style lang="scss" scoped>
.VChart{
  position: relative;
  .EChartCom{
    width: 100%;
    height: 100%;
  }
  .rate{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    color: #fff;
    .title{
      font-size: 16px;
    }
    .rateNum{
      font-size: 26px;
    }
  }
}
</style>
